import { camelCase, slice, upperCase, join } from 'lodash';
import { defaultSendContentSettings, defaultHeaderSettings } from 'components/ScenarioSetup/ActionSidebars/settings/defaultSendContentSettings';
import { StringUse } from 'lib/StringUse';
import { DateUse } from 'lib/DateUse';

const {
    values: { communicationsMaxCount, countTimeIntervalNumber, countTimeIntervalType, templateCache, policyId },
    minDispatchTime,
    maxDispatchTime,
    templateUniqueId,
} = defaultSendContentSettings();

const mappingActionType = actionType => {
    return upperCase(actionType[0]) + join(slice(camelCase(actionType), 1), '');
};

export const sendContentDecompiler = (actionOptions, actionType) => {

    const { receiverContactEmail, receiverContactPhone } = defaultHeaderSettings[mappingActionType(actionType)];

    const {
        receiver_email = receiverContactEmail?.value,
        receiver_phone = receiverContactPhone?.value,
        time_to_send: { to_time, from_time } = { to_time: maxDispatchTime, from_time: minDispatchTime },
        max_frequency,
        template_unique_id = templateUniqueId,
        cache_template = templateCache,
        policy_id = policyId,
    } = actionOptions;

    const localFromTime = DateUse.convertUTCToLocal(from_time, 'HH:mm', 'HH:mm');
    const localToTime = DateUse.convertUTCToLocal(to_time, 'HH:mm', 'HH:mm');

    const selectDefaultHeaderSettings = {
        SendEmail: {
            receiverContactEmail: {
                ...receiverContactEmail,
                value: StringUse.falseyReturnEmptyString(receiver_email)
            }
        },
        SendSms: {
            receiverContactPhone: {
                ...receiverContactPhone,
                value: StringUse.falseyReturnEmptyString(receiver_phone, 'string')
            }
        },
        SendViber: {
            receiverContactPhone: {
                ...receiverContactPhone,
                value: StringUse.falseyReturnEmptyString(receiver_phone, 'string')
            }
        }
    }

    return {
        values: {
            ...selectDefaultHeaderSettings[mappingActionType(actionType)],
            communicationsMaxCount: {
                ...communicationsMaxCount,
                value: StringUse.falseyReturnEmptyString(max_frequency?.n_communications, 'string'),
            },
            countTimeIntervalNumber: {
                ...countTimeIntervalNumber,
                value: StringUse.falseyReturnEmptyString(max_frequency?.period_number, 'string'),
            },
            countTimeIntervalType: {
                ...countTimeIntervalType,
                value: max_frequency?.period_type ? max_frequency?.period_type : 'minutes',
            },
            templateCache: cache_template,
            policyId: {
                value: policy_id
            }
        },
        minDispatchTime: StringUse.falseyReturnEmptyString(localFromTime),
        maxDispatchTime: StringUse.falseyReturnEmptyString(localToTime),
        templateUniqueId: template_unique_id,
    }
};
